import AttributeItem, { AttributeGrid } from 'dashboard/components/AttributeItem';
import { formatAddress } from 'dashboard/lib/utils/formatters';
import { AssociatedPerson, ReportBusinessLookup } from 'dashboard/models/report/business-lookup';
import { ReportTemplateBusinessLookup } from 'dashboard/models/report-template';

interface BusinessLookupProps {
  report: ReportBusinessLookup;
  reportTemplate?: ReportTemplateBusinessLookup;
  isRedacted: boolean;
}

export const BusinessLookup = ({ report, isRedacted }: BusinessLookupProps) => {
  return (
    <AttributeGrid colCount={3}>
      {report.attributes.query?.['business-name'] && (
        <AttributeItem
          title='Business Name'
          value={report.attributes.query?.['business-name']}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-business-lookup__business-name'
        />
      )}
      {report.attributes.query?.['address-street-1'] ? (
        <AttributeItem
          title='Address'
          value={formatAddress({
            addressStreet1: report.attributes.query?.['address-street-1'],
            addressStreet2: report.attributes.query?.['address-street-2'],
            addressCity: report.attributes.query?.['address-city'],
            addressSubdivision: report.attributes.query?.['address-subdivision'],
            addressPostalCode: report.attributes.query?.['address-postal-code'],
          })}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-business-lookup__address'
        />
      ) : report.attributes.query?.['address-city'] ? (
        <AttributeItem
          title='Address'
          value={[
            report.attributes.query?.['address-city'],
            report.attributes.query?.['address-subdivision'],
          ].join(', ')}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-business-lookup__address'
        />
      ) : null}
      {report.attributes['normalized-address-street-1'] && (
        <AttributeItem
          title='Corrected Address'
          value={formatAddress({
            addressStreet1: report.attributes['normalized-address-street-1'],
            addressStreet2: report.attributes['normalized-address-street-2'],
            addressCity: report.attributes['normalized-address-city'],
            addressSubdivision: report.attributes['normalized-address-subdivision'],
            addressPostalCode: report.attributes['normalized-address-postal-code'],
          })}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-business-lookup__address'
        />
      )}
      {report.attributes.query?.['associated-people'] && (
        <AttributeItem
          title='Associated person'
          value={report.attributes.query?.['associated-people']
            .map((person: AssociatedPerson) => person['name-full'])
            .join(', ')}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-business-lookup__associated-person-name_full'
        />
      )}
      {report.attributes['normalized-ein'] ? (
        <AttributeItem
          title='EIN'
          value={report.attributes['normalized-ein']}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-business-lookup__associated-person-ein'
        />
      ) : report.attributes.query?.['ein'] ? (
        <AttributeItem
          title='EIN'
          value={report.attributes.query?.['ein']}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-business-lookup__associated-person-ein'
        />
      ) : null}
      {report.attributes.query?.['phone-number'] && (
        <AttributeItem
          title='Phone Number'
          value={report.attributes.query?.['phone-number']}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-business-lookup__phone-number'
        />
      )}
      {report.attributes.query?.['website'] && (
        <AttributeItem
          title='Website'
          value={report.attributes.query?.['website']}
          placeholder='N/A'
          isRedacted={isRedacted}
          dataTest='report-business-lookup__website'
        />
      )}
    </AttributeGrid>
  );
};
